import { render, staticRenderFns } from "./WfIcon.vue?vue&type=template&id=4d835480&scoped=true"
import script from "./WfIcon.vue?vue&type=script&lang=js"
export * from "./WfIcon.vue?vue&type=script&lang=js"
import style0 from "./WfIcon.vue?vue&type=style&index=0&id=4d835480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d835480",
  null
  
)

export default component.exports